import { render, staticRenderFns } from "./czDialog.vue?vue&type=template&id=48feae66&scoped=true"
import script from "./czDialog.vue?vue&type=script&lang=js"
export * from "./czDialog.vue?vue&type=script&lang=js"
import style0 from "./czDialog.vue?vue&type=style&index=0&id=48feae66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48feae66",
  null
  
)

export default component.exports